import { Download, FileText, Trophy } from "lucide-react";

interface DriverStatsProps {
  totalSetups: number;
  totalDownloads: number;
  activeSeries: number;
}

export function DriverStats({ totalSetups, totalDownloads, activeSeries }: DriverStatsProps) {
  const stats = [
    {
      label: "Total Setups",
      value: totalSetups.toLocaleString(),
      icon: FileText,
    },
    {
      label: "Total Downloads",
      value: totalDownloads.toLocaleString(),
      icon: Download,
    },
    {
      label: "Active Series",
      value: activeSeries.toLocaleString(),
      icon: Trophy,
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-4">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="flex flex-col items-center gap-2 rounded-xl border border-border/50 bg-card/50 p-4 backdrop-blur-sm"
        >
          <stat.icon className="h-5 w-5 text-folk-blue" />
          <span
            className="text-2xl font-bold text-foreground"
            style={{ fontFamily: "'Bebas Neue', sans-serif" }}
          >
            {stat.value}
          </span>
          <span className="text-xs text-muted-foreground">{stat.label}</span>
        </div>
      ))}
    </div>
  );
}
